<div class="container single-view" id="add-unregistered-user">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/unregistered-users/" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'UNREGISTERED_USERS.BTN_BACK_TO_UNREGISTERED_USER' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-unregistered-user-title" class="section-title">{{ 'UNREGISTERED_USER_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-unregistered-user-subtitle" class="section-subtitle mt-1 text-base">{{ 'UNREGISTERED_USER_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <form class="mt-0" [formGroup]="unregisteredUserForm" data-testid="add-unregistered-user-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="add-unregistered-user-details" class="border-b pb-3">{{ 'UNREGISTERED_USER_CREATE.USER_DETAILS' | translate }}</h2>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-unregistered-user-field-firstname" class="block text-sm" for="firstname">{{ 'UNREGISTERED_USER_CREATE.FIRST_NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-unregistered-user-firstname-input" type="text" id="firstname" formControlName="firstname" autocomplete="off">
                  @if (unregisteredUserForm.get('firstname')?.invalid && (unregisteredUserForm.get('firstname')?.touched || unregisteredUserForm.get('firstname')?.dirty)) {
                    <small data-testid="firstname-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-unregistered-user-field-romanisedfirstname" class="block text-sm" for="romanisedFirstName">{{ 'UNREGISTERED_USER_CREATE.ROMANISED_FIRST_NAME' | translate }}</label>
                  <input data-testid="add-unregistered-user-romanisedfirstname-input" type="text" id="romanisedFirstName" formControlName="romanisedFirstName" autocomplete="off">
                  @if (unregisteredUserForm.get('romanisedFirstName')?.invalid && (unregisteredUserForm.get('romanisedFirstName')?.dirty || unregisteredUserForm.get('romanisedFirstName')?.touched)) {
                    @if (unregisteredUserForm.get('romanisedFirstName')?.errors?.['invalidCharacters']) {
                      <small data-testid="romanisedfirstname-format" class="p-error">
                        {{ 'UNREGISTERED_USER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                      </small>
                    }
                  }
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-unregistered-user-field-lastname" class="block text-sm" for="lastname">{{ 'UNREGISTERED_USER_CREATE.LAST_NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-unregistered-user-lastname-input" type="text" id="lastname" formControlName="lastname" autocomplete="off">
                  @if (unregisteredUserForm.get('lastname')?.invalid && (unregisteredUserForm.get('lastname')?.touched || unregisteredUserForm.get('lastname')?.dirty)) {
                    <small data-testid="lastname-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-unregistered-user-field-romanisedlastname" class="block text-sm" for="romanisedLastName">{{ 'UNREGISTERED_USER_CREATE.ROMANISED_LAST_NAME' | translate }}</label>
                  <input data-testid="add-unregistered-user-romanisedlastname-input" type="text" id="romanisedLastName" formControlName="romanisedLastName" autocomplete="off">
                  @if (unregisteredUserForm.get('romanisedLastName')?.invalid && (unregisteredUserForm.get('romanisedLastName')?.dirty || unregisteredUserForm.get('romanisedLastName')?.touched)) {
                    @if (unregisteredUserForm.get('romanisedLastName')?.errors?.['invalidCharacters']) {
                      <small data-testid="romanisedlastname-format" class="p-error">
                        {{ 'UNREGISTERED_USER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                      </small>
                    }
                  }
                </div>
              </div>

              <div class="row">
                <div class="flex flex-col col-12 mb-4 mt-4">
                  <h2 data-testid="add-unregistered-user-retailers-details" class="border-b pb-3">{{ 'UNREGISTERED_USER_CREATE.UNREGISTERED_USER_RETAILERS' | translate }}</h2>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-unregistered-user-field-retailers" class="block text-sm" for="retailerIds">{{ 'UNREGISTERED_USER_CREATE.ASSIGN_RETAILERS' | translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown
                    data-testid="retailers"
                    [placeholder]="'UNREGISTERED_USER_CREATE.SELECT_RETAILERS' | translate"
                    [fieldLabel]="'UNREGISTERED_USER_CREATE.ASSIGN_RETAILERS' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="true"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['retailers'].rowsPerPageOption || 5"
                    [totalCount]="combosData['retailers'].totalRecords"
                    [totalPages]="getComboTotalPages('retailers')"
                    [options]="combosData['retailers'].list"
                    formControlName="retailerIds"
                    (onLazyLoad)="onLazyLoadComboData('retailers', $event)">
                  </app-custom-dropdown>
                  @if (unregisteredUserForm.get('retailerIds')?.invalid && unregisteredUserForm.get('retailerIds')?.touched) {
                    <small data-testid="retailers-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
              </div>

              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-unregistered-user-create-button" class="btn primary-btn" [disabled]="isSubmitDisabled()" (click)="submitForm()">{{
                    'UNREGISTERED_USER_CREATE.BTN_ADD_NEW_UNREGISTERED_USER' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
